<div class="defaultAside aside-open slide-box-show" id="processHolder">
    <a href="javascript:void(0)" class="closebtn" (click)="close()">&times;</a>

    <div class="page-header-banner">
        <h1>Help Topic</h1>
    </div>

    <div class="p-4">

        <form [formGroup]="form" autocomplete="off" novalidate [autocomplete]="'off'" (ngSubmit)="save()">
            <div class="mb-3">
                <label>Topic name</label>
                <input
                    type="text"
                    autocomplete="new-password"
                    class="form-control"
                    [ngClass]="{'is-invalid' : form.controls.name.invalid && form.controls.name.dirty}"
                    formControlName="name"
                    placeholder="Topic name">
                <div class="invalid-feedback">Enter a valid name</div>
            </div>

            <div class="mb-3">
                <label>Topic overview</label>
                <textarea
                    rows="8"
                    type="text"
                    autocomplete="new-password"
                    class="form-control"
                    [ngClass]="{'is-invalid' : form.controls.content.invalid && form.controls.content.dirty}"
                    formControlName="content"
                    placeholder="Topic overview"></textarea>
                <div class="invalid-feedback">Overview content must be entered</div>
            </div>

            <div class="mt-2">
                <a (click)="toggleStatus()">
                    <i
                        class="toggle fa"
                        [ngClass]="{
                        'fa-toggle-on text-success': form.value.status,
                        'fa-toggle-off' : !form.value.status}"></i>
                    Make available?
                </a>
            </div>

            <h3 class="mt-3">Topic Banner</h3>
            <div class="p-2 bg-white">
                <div class="row">
                    <div class="col-4 p-2">
                        <div *ngIf="form.value.bannerUrl" class="product-image-preview border-0" [ngStyle]="{'background-image': 'url(' + form.value.bannerUrl + ')'}">
                            <a class="image-delete" (click)="deleteImage()">
                                <img src="assets/images/icon-trash.svg" class="faq-topics-trash">
                            </a>
                        </div>
                        <img *ngIf="!form.value.bannerUrl" src="/assets/images/no-image.png" class="img-fluid" />
                    </div>

                    <div class="col-8">
                        <div class="dropzone dropzone-container" *ngIf="uploadConfig"
                             [dropzone]="uploadConfig"
                             (error)="onUploadError($event)"
                             (uploadProgress)="uploadprogress($event)"
                             (success)="onUploadSuccess('banner', $event)">

                            <div class="dz-message dz-message-sm" data-dz-message><span>Drag files here or click here to upload</span></div>
                            <div class="dz-details">
                                <div class="dz-filename"><span data-dz-name></span></div>
                                <div class="dz-size" data-dz-size></div>
                                <img data-dz-thumbnail />
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            <h3 class="mt-3">Topic Photo</h3>
            <div class="p-2 bg-white">
                <div class="row">
                    <div class="col-4 p-2">
                        <div *ngIf="form.value.imageUrl" class="product-image-preview border-0" [ngStyle]="{'background-image': 'url(' + form.value.imageUrl + ')'}">
                            <a class="image-delete" (click)="deleteImage()">
                                <img src="assets/images/icon-trash.svg" class="faq-topics-trash">
                            </a>
                        </div>
                        <img *ngIf="!form.value.imageUrl" src="/assets/images/no-image.png" class="img-fluid" />
                    </div>

                    <div class="col-8">
                        <div class="dropzone dropzone-container" *ngIf="uploadConfig"
                             [dropzone]="uploadConfig"
                             (error)="onUploadError($event)"
                             (uploadProgress)="uploadprogress($event)"
                             (success)="onUploadSuccess('image', $event)">

                            <div class="dz-message dz-message-sm" data-dz-message><span>Drag files here or click here to upload</span></div>
                            <div class="dz-details">
                                <div class="dz-filename"><span data-dz-name></span></div>
                                <div class="dz-size" data-dz-size></div>
                                <img data-dz-thumbnail />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-4 text-end">
                <button
                    [disabled]="form.invalid"
                    class="btn btn-round btn-primary mt-4"
                    type="submit"
                    tabindex="3">
                    Submit
                </button>
            </div>

        </form>


    </div>
</div>
